/**
 * User profile + Complete profile actions
 */
export const PROFILE_ACTIONS = {
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  PROFILE_COMPLETED: 'profile_completed',
  PROFILE_FAILED: 'profile_failed',
  USER_TYPE_SELECTED: 'user_type_selected',
  PROFILE_UPDATED: 'profile_updated',
  TAB_CHANGED: 'tab_changed',
  PASSWORD_CHANGED: 'password_changed',
  ORG_MEMBER_MANAGED: 'org_member_managed',
  DATA_EXPORT_COMPLETED: 'data_export_completed',
  ACCOUNT_DELETION_SCHEDULED: 'account_deletion_scheduled',
  ACCOUNT_DELETION_CANCELLED: 'account_deletion_cancelled',
} as const;

export const ORGANIZATION_ACTIONS = {
  TAB_CHANGED: 'tab_changed',
  SETTINGS_UPDATED: 'settings_updated',
  MEMBER_INVITED: 'member_invited',
  MEMBER_REMOVED: 'member_removed',
} as const;
